export const FREE_TRIAL_ELIGIBLE_AGAIN_SEARCH_PARAM = 'free-trial-eligible-again'
